import { RouteConfig } from 'vue-router'

const LearningRoutes: Array<RouteConfig> = [
  {
    path: 'dashboard',
    name: 'learning.dashboard',
    meta: {
      title: 'Dashboard',
      layout: 'learning',
      requireAuth: true,
      permissions: 'learning.access.view'
    },
    props: true,
    component: () => import('@/modules/level-two/views/learning/dashboard/dashboard.view.vue')
  },
  {
    path: 'people',
    name: 'learning.people',
    meta: {
      title: 'People',
      layout: 'learning',
      requireAuth: true,
      permissions: 'learning.access.view'
    },
    component: () => import('@/modules/level-two/views/learning/people/index.view.vue'),
    children: [
      {
        path: 'learners',
        name: 'learning.people.learners',
        meta: {
          title: 'Learners',
          layout: 'learning',
          requireAuth: true,
          permissions: 'learning.access.view'
        },
        component: () => import('@/modules/level-two/views/learning/people/learners.view.vue')
      },
      {
        path: 'groups',
        name: 'learning.people.groups',
        meta: {
          title: 'Groups',
          layout: 'learning',
          requireAuth: true,
          permissions: 'learning.access.view'
        },
        component: () => import('@/modules/level-two/views/learning/people/groups/groups.view.vue')
      }
      // {
      //   path: 'instructors',
      //   name: 'learning.people.instructors',
      //   meta: {
      //     title: 'Instructors',
      //     layout: 'learning',
      //     requireAuth: true,
      //     permissions: 'learning.access.view'
      //   },
      //   component: () => import('@/modules/level-two/views/learning/people/instructors.view.vue')
      // },
      // {
      //   path: 'roles',
      //   name: 'learning.people.roles',
      //   meta: {
      //     title: 'Roles',
      //     layout: 'learning',
      //     requireAuth: true,
      //     permissions: 'learning.access.view'
      //   },
      //   component: () => import('@/modules/level-two/views/learning/people/roles.view.vue')
      // }
    ]
  },
  {
    path: 'content',
    name: 'learning.content',
    meta: {
      title: 'Content',
      layout: 'learning',
      requireAuth: true,
      permissions: 'learning.access.view'
    },
    props: true,
    component: () => import('@/modules/level-two/views/learning/content/index.view.vue'),
    children: [
      {
        path: 'courses',
        name: 'learning.content.courses',
        meta: {
          title: 'Courses',
          layout: 'learning',
          requireAuth: true,
          permissions: 'learning.access.view'
        },
        component: () => import('@/modules/level-two/views/learning/content/courses/courses.view.vue')
      },
      {
        path: 'course/:event_uuid',
        name: 'learning.content.course',
        meta: {
          title: 'Course',
          layout: 'learning',
          requireAuth: true,
          permissions: 'learning.courses.view_details'
        },
        props: true,
        component: () => import('@/modules/level-two/views/learning/content/course/course.view.vue')
      },
      {
        path: 'course/:event_uuid/settings',
        name: 'learning.content.course.settings',
        meta: {
          title: 'Course Settings',
          layout: 'learning',
          requireAuth: true,
          permissions: 'learning.courses.view_details'
        },
        props: true,
        component: () => import('@/modules/level-two/views/learning/content/course/settings.view.vue')
      },
      {
        path: 'course/:event_uuid/ceu/create',
        name: 'learning.content.course.ceu.create',
        meta: {
          title: 'CEU | Create',
          layout: 'learning',
          requireAuth: true,
          permissions: 'learning.chapters.view'
        },
        props: true,
        component: () => import('@/modules/level-two/views/learning/ceu/createOrEdit.view.vue')
      },
      {
        path: 'course/:event_uuid/ceu/edit',
        name: 'learning.content.course.ceu.edit',
        meta: {
          title: 'CEU | Edit',
          layout: 'learning',
          requireAuth: true,
          permissions: 'learning.chapters.view'
        },
        props: true,
        component: () => import('@/modules/level-two/views/learning/ceu/createOrEdit.view.vue')
      },
      {
        path: 'course/:event_uuid/certificate/assign',
        name: 'learning.content.course.certificate.assign',
        meta: {
          title: 'Assign Certificate',
          layout: 'learning',
          requireAuth: true,
          permissions: 'learning.chapters.view'
        },
        props: true,
        component: () => import('@/modules/level-two/views/learning/assign-certificate/assign-certificate.view.vue')
      },
      {
        path: 'course/:event_uuid/files',
        name: 'learning.content.course.files',
        meta: {
          title: 'Course Files',
          layout: 'learning',
          requireAuth: true,
          permissions: 'learning.chapters.view'
        },
        props: true,
        component: () => import('@/modules/level-two/views/learning/files/files.view.vue')
      },
      {
        path: 'course/:event_uuid/emails',
        name: 'learning.content.course.emails',
        meta: {
          title: 'Course Emails',
          layout: 'learning',
          requireAuth: true,
          permissions: 'learning.chapters.view'
        },
        props: true,
        component: () => import('@/modules/level-two/views/learning/emails/index.view.vue')
      },
      {
        path: 'course/:event_uuid/emails/:email_uuid',
        name: 'learning.content.course.email.edit',
        meta: {
          title: 'Course Emails',
          layout: 'learning',
          requireAuth: true,
          permissions: 'learning.chapters.view'
        },
        props: true,
        component: () => import('@/modules/level-two/views/learning/emails/edit.view.vue')
      },
      {
        path: 'course/:event_uuid/chapter/:session_uuid',
        name: 'learning.content.course.chapter',
        meta: {
          title: 'Chapter',
          layout: 'learning',
          requireAuth: true,
          permissions: 'learning.chapters.view'
        },
        props: true,
        component: () => import('@/modules/level-two/views/learning/content/course/chapters/chapter/index.view.vue')
      },
      {
        path: 'course/:event_uuid/chapter/:session_uuid/content/:content_id?',
        name: 'learning.content.course.chapter.content',
        meta: {
          title: 'Edit Chapter Content',
          layout: 'learning',
          requireAuth: true,
          permissions: 'learning.courses.edit'
        },
        component: () => import('@/modules/level-two/views/learning/content/course/chapters/chapter-content/index.view.vue')
      },
      {
        path: 'certificates',
        name: 'learning.content.certificates',
        meta: {
          title: 'Certificates',
          layout: 'learning',
          requireAuth: true,
          permissions: 'learning.certificates.view'
        },
        props: true,
        component: () => import('@/modules/level-two/views/learning/content/certificates/certificates.view.vue')
      },
      {
        path: 'ceu-management',
        name: 'learning.content.ceu_management',
        meta: {
          title: 'CEU Management',
          layout: 'learning',
          requireAuth: true,
          permissions: 'learning.access.view'
        },
        props: true,
        component: () => import('@/modules/level-two/views/learning/content/ceu_management.view.vue')
      }
    ]
  },
  {
    path: 'course/:event_uuid/reports',
    name: 'learning.course.reports',
    meta: {
      title: 'Reports',
      layout: 'learning',
      requireAuth: true,
      permissions: 'general.reports.view'
    },
    component: () => import('@/modules/level-two/views/learning/reports/course/reports.view.vue')
  },
  {
    path: 'course/:event_uuid/reports/:report_uuid',
    name: 'learning.course.report.view',
    meta: {
      title: 'Report',
      layout: 'learning',
      requireAuth: true,
      permissions: 'general.reports.view'
    },
    component: () => import('@/modules/level-two/views/learning/reports/course/view/view.view.vue')
  },
  // {
  //   path: 'emails',
  //   name: 'learning.emails',
  //   meta: {
  //     title: 'Emails',
  //     layout: 'learning',
  //     requireAuth: true,
  //     permissions: 'learning.access.view'
  //   },
  //   component: () => import('@/modules/level-two/views/learning/emails.view.vue')
  // },
  {
    path: 'settings',
    name: 'learning.settings',
    meta: {
      title: 'Settings',
      layout: 'learning',
      requireAuth: true,
      permissions: 'learning.courses.edit'
    },
    component: () => import('@/modules/level-two/views/learning/settings/settings.view.vue')
  }
]

export default LearningRoutes
